import ADF from "entity/Indicador/ADF";
import AltC from "entity/Indicador/AltC";
import EES from "entity/Indicador/EES";
import NGV from "entity/Indicador/NGV";
import Perdas from "entity/Indicador/Perdas";
import Piso from "entity/Indicador/Piso";
import PS from "entity/Indicador/PS";
import VCC from "entity/Indicador/VCC";
import ADC from "entity/Indicador/ADC";
import TTP from "entity/Indicador/TTP";
import PDT from "entity/Indicador/PDT";
import Falhas from "entity/Indicador/Falhas";
import CM from "entity/Indicador/CM";
import Perf from "entity/Indicador/Perf"
import TipoIndicador from "..";
import AC from "entity/Indicador/AC";

export default class Plantio extends TipoIndicador {
    static get fullName() {
        return "Plantio";
    }

    static get abbrev() {
        return "Plantio";
    }

    static get field() {
        return "plantio";
    }

    static get indicadores() {
        return [NGV, ADF, CM, EES, VCC, PS, AltC, Perdas, Piso, ADC, Falhas, PDT, TTP, Perf, AC];
    }
}
